import React from 'react';

/**
 * Standardized Back Button Component
 * Used consistently across all pages and forms
 */
const BackButton = ({ 
  onClick, 
  label = '← Back',
  variant = 'default',
  className = '',
  disabled = false 
}) => {
  const baseStyles = 'flex items-center gap-2 px-4 py-2 rounded-lg font-medium transition-all duration-200';
  
  const variants = {
    default: 'bg-gray-100 text-gray-700 hover:bg-gray-200 active:bg-gray-300',
    primary: 'bg-blue-100 text-blue-700 hover:bg-blue-200 active:bg-blue-300',
    danger: 'bg-red-100 text-red-700 hover:bg-red-200 active:bg-red-300',
    ghost: 'bg-transparent text-gray-600 hover:bg-gray-100 active:bg-gray-200'
  };
  
  const disabledStyles = 'opacity-50 cursor-not-allowed';
  
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={`
        ${baseStyles}
        ${variants[variant] || variants.default}
        ${disabled ? disabledStyles : 'cursor-pointer'}
        ${className}
      `}
      type="button"
    >
      <svg 
        className="w-5 h-5" 
        fill="none" 
        stroke="currentColor" 
        viewBox="0 0 24 24"
      >
        <path 
          strokeLinecap="round" 
          strokeLinejoin="round" 
          strokeWidth={2} 
          d="M10 19l-7-7m0 0l7-7m-7 7h18" 
        />
      </svg>
      <span>{label}</span>
    </button>
  );
};

export default BackButton;
